import React, { useEffect, useState } from 'react';
// reactstrap components
// import { Container, Row, Col, Table, Progress } from 'reactstrap';
import { API, getDataCookie } from 'common';
import AvatarEditorModal from 'components/AvatarEditor/AvatarEditorModal';
import MyDatePicker from 'components/DatePicker';
import Loader from 'components/Loader';
import Page from 'components/Page';
import { merge } from 'lodash';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { useHistory } from 'react-router-dom';
import {
	Container
} from 'reactstrap';
import { formatCurrency, formatNumber } from 'utils/formatCurrency';
import type { Staff as StaffModel, StaffDailyReport } from 'types/models';

// GET /admin/staff merged with GET /report/reportStaffDaily by staffId.
// Aliased on import since this file also declares a local `Staff` component.
type StaffWithReport = StaffModel & Partial<StaffDailyReport>;

const TAB = {
	TODAY: "TODAY",
	YESTERDAY: "YESTERDAY",
	CUSTOM: "CUSTOM",
};

const FORMAT_DATE = 'MM-DD-YYYY';
const FORMAT_DATE_PAYLOAD = 'YYYY-MM-DD';


export default function StaffList() {
	const _history = useHistory();
	const [dataList, setDataList] = React.useState<StaffWithReport[]>([]);
	const [activeTab, setActiveTab] = useState(TAB.TODAY);
	const [loading, setLoading] = useState(false);
	// Staff whose photo is being edited; this route is manager-only, the BE
	// still re-checks that the requester is an Admin of the shop.
	const [avatarStaffId, setAvatarStaffId] = useState<number | null>(null);
	const requesterStaffId = getDataCookie(process.env.REACT_APP_COOKIE_KEY as string);
	const onAvatarUpdated = (urlImage: string) => {
		setDataList(list => list.map(o => (o.id === avatarStaffId ? { ...o, urlImage } : o)));
	};

	const toggle = (tab: string) => {
		let range_param = '';
		const now = new Date();
		switch (tab) {

			case TAB.YESTERDAY: {
				const dateMoment = moment(now).subtract(1, 'day').format(FORMAT_DATE_PAYLOAD);
				range_param = `startDate=${dateMoment}&endDate=${dateMoment}`;
				break;
			}
			case TAB.TODAY:
			case TAB.CUSTOM:
			default: {
				const dateMoment = moment(now).format(FORMAT_DATE_PAYLOAD);
				range_param = `startDate=${dateMoment}&endDate=${dateMoment}`;
				break;
			}
		}
		fetchDataApt(range_param);
		if (activeTab !== tab) setActiveTab(tab);
	};

	const fetchDataApt = async (params: string) => {
		const search = new URLSearchParams(params);
		const startDate = search.get('startDate');

		setLoading(true);
		try {
			let [res, resReport] = await Promise.all([API.get(`/admin/staff`), API.get(`/report/reportStaffDaily?date=${startDate}`)]);
			if (res.data.payload && resReport.data.payload) {
				setDataList(res.data.payload.map((o: StaffModel) => {
					const report = resReport.data.payload?.find((rp: StaffDailyReport) => rp.staffId?.toString() === o.id?.toString());
					return {
						id: o.id,
						nickName: o.nickName,
						firstName: o.firstName,
						positionName: o.positionName,
						strClockInTime: o.strClockInTime,
						urlImage: o.urlImage,
						phone: o.phone,
						...report
					};
				}));
			}
		} catch (error) {
			console.error('get_staff_data', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		toggle(TAB.TODAY);
	}, []);

	const handleClickStaff = (staff: StaffWithReport) => {
		_history.push(`/ticket-by-staff/${staff.id}`);
	};

	const Staffs = () => {
		return (
			<div className='staff_list_ui_kit_staffs' style={{ marginTop: 8 }}>
				{
					dataList.length > 0 &&
					dataList.map((item, index) => {
						return (
							<StaffV2
								key={item.id}
								data={item}
								onClick={() => handleClickStaff(item)}
								onEditAvatar={requesterStaffId ? () => setAvatarStaffId(item.id as number) : undefined}
							/>
						)
					})
				}
			</div>
		)
	};

	return (
		<>
			{loading && <Loader />}
			<Page menu title={'Staff List'}>
				<Container className="overview m-0 px-0 pt-0 staff_list_ui_kit" style={{ paddingBottom: '60px' }}>
					<div style={{ padding: '8px 16px', position: 'sticky', top: 0, background: '#fff', zIndex: 2 }}>
						<div className="d-flex align-items-center" style={{ gap: '24px' }}>
							<MyDatePicker
								daily
								stringData={fetchDataApt}
								unsetMaxDate
								style={{ flex: 1 }}
								format='YYYY-MM-DD'
								customRender={({ icon, date }) => {
									return (
										<div className='date_picker_appointment staff_list_ui_kit_date_picker' >
											<span> Report date {date?.format(FORMAT_DATE)}</span>
											{icon}
										</div>)
								}}
							/>
						</div>
						<div className="staff_list_thead_v2">
							<div className="staff_list_thead_v2_item" style={{ flex: 1 }}><span>STAFF ({dataList.length ? dataList.length : 0})</span></div>
							<div className="staff_report_dashboards">
								<div className="staff_report_dashboard_item SALE"><span>SALE</span></div>
								<div className="staff_report_dashboard_item TIP"><span>TIP</span></div>
								<div className="staff_report_dashboard_item SUPPLY"><span>SUPPLY</span></div>
							</div>
						</div>
					</div>
					<div className='staff_list_ui_kit_container'>
						<Staffs />
					</div>
				</Container>
				{!!avatarStaffId && !!requesterStaffId && (
					<AvatarEditorModal
						isOpen
						staffId={avatarStaffId}
						requesterStaffId={requesterStaffId}
						onClose={() => setAvatarStaffId(null)}
						onUpdated={onAvatarUpdated}
					/>
				)}
			</Page>
		</>
	);
}


const StaffV2 = ({ data, onClick = () => undefined, onEditAvatar }: { data: StaffWithReport; onClick?: () => void; onEditAvatar?: () => void }) => {
	return (
		<div className='staff_list_ui_kit_staff_item v2'>
			<div className="staff_list_ui_kit_staff_item_avatar_group" onClick={e => [e.preventDefault(), onClick()]}>
				<img className='avatar_img urlImage' src={data.urlImage ? data.urlImage : require('assets/img/icons/avatar-sample.jpg')} />
				{!!onEditAvatar && (
					// stopPropagation: the surrounding avatar group navigates to the staff's tickets
					<button
						type="button"
						className="staff_avatar_edit_btn"
						aria-label="Change photo"
						onClick={e => {
							e.preventDefault();
							e.stopPropagation();
							onEditAvatar();
						}}
					>
						✎
					</button>
				)}
			</div>
			<div className="staff_list_ui_kit_staff_item_detail">
				<div className="staff_list_ui_kit_staff_item_detail_info">
					<div className='staff_name_group' onClick={e => [e.preventDefault(), onClick()]}>
						<div className="staff_name">{data.nickName || data.firstName}</div>
					</div>
					<div className='staff_content_group'>
						<div className="staff_report_dashboards">
							<div className="staff_report_dashboard_item SALE"><span>{formatCurrency(data.totalSaleToday)}</span></div>
							<div className="staff_report_dashboard_item TIP"><span>{formatCurrency(data.totalTip)}</span></div>
							<div className="staff_report_dashboard_item SUPPLY"><span>{formatCurrency(data.totalSupply)}</span></div>
						</div>
					</div>
				</div>
				<div className="staff_list_ui_kit_staff_item_detail_info">
					<div className='staff_name_group' onClick={e => [e.preventDefault(), onClick()]}>
						<div className="staff_position">{data.positionName || '--'}</div>
					</div>
				</div>
				<button className="staff_info_calling_iconV2" onClick={e => [e.stopPropagation(), window.open('tel:' + data.phone)]}>
					<IconPhone />
					<span>Call</span>
				</button>
			</div>
		</div>
	)
};
const Staff = ({ data, onClick = () => undefined }: { data: StaffWithReport; onClick?: () => void }) => {
	return (
		<div className='staff_list_ui_kit_staff_item'>
			<div className="staff_list_ui_kit_staff_item_avatar_group" onClick={e => [e.preventDefault(), onClick()]}>
				<img className='avatar_img urlImage' src={data.urlImage ? data.urlImage : require('assets/img/icons/avatar-sample.jpg')} />
				<div className="staff_id id">
					<span>#{data.id}</span>
				</div>
			</div>
			<div className="staff_list_ui_kit_staff_item_detail">
				<div className="staff_list_ui_kit_staff_item_detail_info">
					<div className='staff_name_group' onClick={e => [e.preventDefault(), onClick()]}>
						<div className="staff_name">{data.nickName || data.firstName}</div>
						<div className="staff_clock_in clockInTimeCheck">Clock in: {moment(new Date(data.clockInTimeCheck!)).format('HH:mm:ss A')}</div>
					</div>
					<button className="staff_info_calling_icon" onClick={e => [e.stopPropagation(), window.open('tel:' + data.phone)]}>
						<IconPhone />
					</button>
				</div>

				<div className="staff_list_ui_kit_staff_item_detail_dashboards">
					<div className="staff_list_ui_kit_staff_item_detail_dashboard">
						<div className="staff_list_ui_kit_staff_item_detail_dashboard_item bold">
							<span className="label">TURN</span>
							<span className="value turn">{data.turn}</span>
						</div>
						<div className="staff_list_ui_kit_staff_item_detail_dashboard_item">
							<span className="label">Appt</span>
							<span className="value totalAppointment">{formatNumber(data.totalAppointment)}</span>
						</div>
						<div className="staff_list_ui_kit_staff_item_detail_dashboard_item">
							<span className="label">SERVICES</span>
							<span className="value totalServices">{formatCurrency(data?.totalSaleService || 0)}</span>
						</div>
					</div>
					<div className="staff_list_ui_kit_staff_item_detail_dashboard">
						<div className="staff_list_ui_kit_staff_item_detail_dashboard_item">
							<span className="label">TIP</span>
							<span className="value totalTip">{formatCurrency(data.totalTip)}</span>
						</div>
						<div className="staff_list_ui_kit_staff_item_detail_dashboard_item">
							<span className="label">SALE</span>
							<span className="value totalSales">{formatCurrency(data.totalSaleToday)}</span>
						</div>
						<div className="staff_list_ui_kit_staff_item_detail_dashboard_item">
							<span className="label">SUPPLY</span>
							<span className="value supply">{formatCurrency(data.totalSupply)}</span>
						</div>
					</div>

				</div>
			</div>
		</div>
	)
};

const IconPhone = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M10.9783 1.97676C11.1279 1.76801 11.3899 1.64594 11.6463 1.67C12.4386 1.75881 13.217 1.97075 13.9438 2.29874C15.6495 3.06476 17.0469 4.49349 17.7729 6.21766C18.064 6.8839 18.2352 7.59579 18.3335 8.31476V8.49237C18.2995 8.80409 18.0594 9.08396 17.7492 9.14694C17.4546 9.22018 17.1268 9.0875 16.9606 8.83487C16.8145 8.63036 16.8226 8.36783 16.7784 8.13041C16.5765 6.9812 16.0368 5.89144 15.2354 5.04297C14.2854 4.01902 12.9648 3.34852 11.5781 3.184C11.3206 3.161 11.0646 3.0315 10.9365 2.79975C10.7855 2.5496 10.8014 2.20957 10.9783 1.97676Z" fill="white" />
		<path d="M2.71529 2.81523C3.05205 2.60807 3.44612 2.50347 3.84053 2.50076C4.55305 2.49975 5.2659 2.49975 5.97876 2.50076C6.32535 2.50279 6.6733 2.57422 6.98327 2.73162C7.60388 3.03221 8.05255 3.64863 8.16074 4.32733C8.24518 4.90583 8.36693 5.48061 8.56363 6.03237C8.63111 6.23311 8.70776 6.43282 8.74099 6.64303C8.81458 7.07124 8.75354 7.52077 8.56871 7.91412C8.36896 8.37245 7.9637 8.68523 7.63067 9.04201C8.46969 10.3747 9.61731 11.5084 10.9443 12.357C11.2401 12.0743 11.5042 11.75 11.858 11.5358C12.4023 11.1898 13.1063 11.1228 13.713 11.3364C14.2431 11.5219 14.7833 11.6861 15.3398 11.7704C15.6474 11.8161 15.9621 11.8628 16.2443 12.0009C16.9744 12.3292 17.476 13.0915 17.4977 13.8897C17.5015 14.6463 17.4977 15.4032 17.4998 16.1597C17.5049 16.7582 17.2447 17.3533 16.8025 17.7575C16.4515 18.0868 15.9862 18.2882 15.5067 18.3258C15.2903 18.3485 15.0736 18.3153 14.8596 18.2862C11.7667 17.9118 8.82238 16.5209 6.52137 14.4327C4.88065 12.9426 3.60246 11.0727 2.73903 9.03727C2.28357 7.92089 1.94953 6.7544 1.77047 5.56151C1.72943 5.20168 1.63753 4.84253 1.67551 4.47796C1.73079 3.80062 2.13029 3.16288 2.71529 2.81523ZM3.71403 3.95294C3.38202 4.00304 3.11309 4.31413 3.1114 4.64925C3.41628 7.80106 4.88879 10.8114 7.14266 13.033C9.24426 15.0823 12.0085 16.46 14.9264 16.8411C15.1496 16.8689 15.388 16.938 15.604 16.8401C15.8767 16.7355 16.0639 16.4488 16.0537 16.158C16.0551 15.4245 16.0527 14.6913 16.0551 13.9578C16.0469 13.6741 15.8675 13.3925 15.5955 13.2943C15.4026 13.2263 15.1957 13.2147 14.9959 13.1772C14.5527 13.1007 14.1166 12.9883 13.6883 12.8522C13.5126 12.7943 13.3393 12.728 13.1609 12.6792C12.9137 12.6115 12.6373 12.6999 12.4626 12.8844C12.1622 13.1819 11.8654 13.4832 11.5636 13.7794C11.352 13.9909 11.0071 14.0471 10.7385 13.9165C9.3494 13.1284 8.10953 12.075 7.12265 10.8198C6.91476 10.5707 6.73842 10.2979 6.54613 10.0369C6.39521 9.81245 6.26227 9.57651 6.11746 9.34802C5.98249 9.14492 5.95298 8.87411 6.05133 8.65036C6.11068 8.50616 6.227 8.39818 6.33553 8.29087C6.59496 8.0309 6.85915 7.77601 7.11723 7.51468C7.24983 7.37285 7.33495 7.18024 7.32274 6.98425C7.32206 6.82718 7.25288 6.68298 7.20811 6.53573C7.00192 5.94639 6.84796 5.33776 6.7608 4.71932C6.73299 4.55954 6.70755 4.39063 6.60785 4.25726C6.47016 4.05416 6.22361 3.93839 5.98012 3.94685C5.22487 3.95125 4.46894 3.93906 3.71403 3.95294Z" fill="white" />
		<path d="M11.4746 4.19163C11.6023 4.16008 11.736 4.1589 11.8642 4.18768C12.8465 4.38757 13.7685 4.88197 14.4685 5.6007C15.1713 6.30998 15.648 7.23609 15.8271 8.21779C15.8539 8.43818 15.7967 8.67198 15.6563 8.84585C15.4891 9.06072 15.2127 9.1853 14.941 9.1648C14.6385 9.14745 14.3522 8.95269 14.2315 8.67434C14.1495 8.48628 14.1353 8.27811 14.0639 8.0865C13.7153 6.98652 12.7554 6.10299 11.6252 5.86052C11.4075 5.81794 11.1867 5.73318 11.0408 5.55852C10.8389 5.32867 10.775 4.98408 10.8913 4.69982C10.9868 4.44789 11.2127 4.25234 11.4746 4.19163Z" fill="white" />
	</svg>
);
